import React, { useEffect, useState } from 'react'
import { Chart, Legend, PieSeries } from '@devexpress/dx-react-chart-material-ui'
import { CircularProgress, Grid, Typography } from '@material-ui/core'
import { Animation } from '@devexpress/dx-react-chart'
import { getLabelTipoExameRealizado } from 'helpers/labels'

import { useExameRealizadoService } from 'hooks/useExameRealizadoService'
import useStyles from './styles'

export const PieTiposExamesRealizados = () => {
  const [processandoDados, setProcessandoDados] = useState(false) //eslint-disable-line
  const [examesRealizadosPorTipo, setExamesRealizadosPorTipo] = useState([])
  const exameRealizadoService = useExameRealizadoService()
  useEffect(() => {
    const fetchExamesRealizadosPorTipo = async () => {
      const response =
        await exameRealizadoService.listarQuantidadeExamesRealizadosDeUsuarioPorTipoAsync(
          setProcessandoDados
        )
      let listaComNomesTratados = []
      listaComNomesTratados = response.map((exame) => ({
        ...exame,
        tipo: getLabelTipoExameRealizado(exame.tipo),
      }))
      if (listaComNomesTratados.length) {
        setExamesRealizadosPorTipo(listaComNomesTratados)
      } else {
        setExamesRealizadosPorTipo([{ tipo: 'NENHUM REGISTRADO', count: 1 }])
      }
    }
    fetchExamesRealizadosPorTipo()
   
  }, [])

  const classes = useStyles()
  return (
    <div>
      {processandoDados ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <div>
          {examesRealizadosPorTipo.length ? (
            <Chart data={examesRealizadosPorTipo} className={classes.chart}>
              <PieSeries valueField="count" argumentField="tipo" />
              <Legend />
              <Animation />
            </Chart>
          ) : (
            <Grid container justifyContent="center" alignItems="center">
              <Typography className={classes.nenhumexame} variant="h5">
                Exames Realizados por tipo
              </Typography>
            </Grid>
          )}
        </div>
      )}
    </div>
  )
}
